import React, { memo, useCallback } from 'react';
import Magnifier from '@splunk/react-icons/Magnifier';
import type { DataSourceDefinition } from '@splunk/dashboard-types';
import { ActionButton, useActionButtonClick } from '../ActionButton';
import { resolvedSearch, type ResolvedSearchProps } from './resolvedSearch';

const searchIcon = <Magnifier />;

const noop = () => undefined;

type ActionButtonWrapperProps = {
    onOpenSearchClick: (definition: DataSourceDefinition | null) => void;
    screenReaderText: string;
    disabled: boolean;
} & ResolvedSearchProps;

export const ActionButtonWrapper = memo(
    ({
        onOpenSearchClick = noop,
        screenReaderText,
        disabled,
        dataSourceId,
        dataSourceDef,
        dashboardApi,
    }: ActionButtonWrapperProps): JSX.Element => {
        const openSearchCallback = useCallback(() => {
            onOpenSearchClick(
                resolvedSearch({
                    dataSourceId,
                    dataSourceDef,
                    dashboardApi,
                })
            );
        }, [dataSourceId, dataSourceDef, dashboardApi, onOpenSearchClick]);

        const handleClick = useActionButtonClick(
            'openSearch',
            openSearchCallback
        );

        return (
            <ActionButton
                data-test="open-search-button"
                onClick={handleClick}
                icon={searchIcon}
                disabled={disabled}
                title={screenReaderText}
            />
        );
    }
);
